.cardStack {
  position: relative;
  width: 76px;
  height: 88px;
  margin-bottom: 8px;
}

.cardStack::before,
.cardStack::after,
.card {
  position: absolute;
  inset: 0;
  border-radius: 16px;
  border: 1px solid var(--colors-grays-ultralight);
  padding: 8px;
  background: var(--colors-grays-white);
}

/* back card */
.cardStack::before {
  content: "";
  right: -3px;
}

/* middle card */
.cardStack::after {
  content: "";
  transform: rotate(-17deg);
  bottom: -3px
}

/* front card */
.card {
  z-index: 1;
  transform: rotate(-7deg);
}

/* counter-rotate icon so it stays upright */
.icon {
  transform: rotate(7deg);
}
